import React from 'react';
import { useLocation } from 'react-router-dom';
import { useActivation } from './useActivation';
import { useStepClickHandler } from './useStepClickHandler';
import { ACTIVATION_STEPS } from './checklistSteps';
import { SidebarChecklist } from './variants/SidebarChecklist';

/**
 * Activation Checklist
 *
 * Renders the sidebar checklist for user onboarding.
 * Positioned bottom-right, above other FABs.
 */
export function ActivationChecklistSwitcher() {
  const location = useLocation();
  const handleStepClick = useStepClickHandler();
  const {
    isActive,
    activation,
    currentStepIndex,
    completedCount,
  } = useActivation();

  // Don't render on SuperAdmin screen
  if (location.pathname.includes('super-admin')) {
    return null;
  }

  // Don't render anything if activation is off or user reached deep
  if (!isActive || !activation) {
    return null;
  }

  return (
    <SidebarChecklist
      activation={activation}
      steps={ACTIVATION_STEPS}
      currentStepIndex={currentStepIndex}
      completedCount={completedCount}
      onStepClick={handleStepClick}
    />
  );
}

/**
 * Alias for ActivationChecklistSwitcher
 * @deprecated Use ActivationChecklistSwitcher instead
 */
export const ActivationSidebarChecklist = ActivationChecklistSwitcher;

/**
 * @deprecated Floating variant has been removed. Returns null.
 */
export function ActivationFloatingChecklist() {
  return null;
}

/**
 * @deprecated Banner variant has been removed. Returns null.
 */
export function ActivationBannerChecklist() {
  return null;
}
